import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-goods_manage",
  "use": "icon-goods_manage-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-goods_manage\"><defs><style></style></defs><path d=\"M927.5 1024h-831c-18.9 0-34.1-15.3-34.1-34.1V34.1C62.3 15.3 77.6 0 96.5 0h831.1c18.9 0 34.1 15.3 34.1 34.1v955.7c0 18.9-15.3 34.2-34.2 34.2zm-796.9-68.3h762.8V68.3H130.6v887.4z\" /><path d=\"M512 442.3c-121.9 0-221.1-99.2-221.1-221.1 0-18.9 15.3-34.1 34.1-34.1s34.1 15.3 34.1 34.1c0 84.3 68.6 152.9 152.8 152.9 84.3 0 152.9-68.6 152.9-152.9 0-18.9 15.3-34.1 34.1-34.1s34.1 15.3 34.1 34.1c.1 121.9-99.1 221.1-221 221.1zm187 290.8H325c-18.9 0-34.1-15.3-34.1-34.1s15.3-34.1 34.1-34.1h374c18.9 0 34.1 15.3 34.1 34.1s-15.2 34.1-34.1 34.1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/goods_manage.svg
// module id = 3jpC
// module chunks = 78